<template>
  <PageLayout>
    <template #headerTitle> Pronostics </template>
    <div class=" pb-32 px-4">
      <PronosticMatchs></PronosticMatchs>
    </div>
  </PageLayout>
</template>

<script setup>
import { ref } from 'vue';

const type = ref('free');
</script>
